import { useEffect } from 'react';
import type { PublicVitalsContext } from '@/public/vitals';

/**
 * Ревизия пачки 29, п.13 — ПРОВОДКА СБОРА ПОКАЗАТЕЛЕЙ СКОРОСТИ (WEB-1992).
 *
 * Модуль `public/vitals.ts` был написан и покрыт тестами, но его никто не
 * звал: ни на одной странице публичного контура — то есть замеров не
 * существовало вовсе. Здесь ровно проводка, без своей логики: у модуля своя
 * ответственность (что собирать и куда слать), у страницы — своя (кто она и
 * какой это шаг).
 *
 * ЗАЧЕМ ХУК, А НЕ ВЫЗОВ В КАЖДОЙ СТРАНИЦЕ РУКАМИ. Возвращаемая функция
 * остановки обязана быть вызвана на СМЕНЕ ШАГА: внутри одной загрузки
 * страницы `pagehide` не случается, и без остановки накопленное за прежний
 * шаг либо уехало бы с чужой меткой шага, либо не уехало бы вовсе. Один хук
 * — одно правило на обе страницы (сторож разъезда: они здесь не могут
 * разойтись по построению).
 *
 * ЧТО ИМЕННО ДЕЛАЕТ ОСТАНОВКА (уточнено по находке 5А-3 пятого прохода
 * свежего взгляда — прежде здесь было написано «снимает слушателей», и это
 * читалось как «снимает наблюдателей библиотеки»). Она снимает слушателей
 * УХОДА СО СТРАНИЦЫ самого модуля замеров, снимает метку текущего шага и
 * досылает пакет этого шага. Наблюдатели `web-vitals` ею не снимаются и не
 * могут: отписки у библиотеки нет, поэтому модуль подписывается на них ровно
 * один раз за жизнь документа.
 *
 * Адрес приёмника НЕ передаём: умолчание модуля (наш API) — его дело, второй
 * копии этого решения тут быть не должно.
 *
 * ПОЧЕМУ МОДУЛЬ ГРУЗИТСЯ ОТЛОЖЕННО. Он тянет за собой библиотеку измерений
 * (`web-vitals`), а публичный вход собран отдельно и под бюджетом размера
 * (WEB-1988) — замер не имеет права утяжелять то, что он измеряет, и обязан
 * ждать, пока страница покажется. Отказ загрузки замера показ не роняет
 * (наблюдаемость никогда не мешает покупателю).
 */
export function usePublicVitalsStep(
  context: PublicVitalsContext | null,
): void {
  const projectId = context?.projectId;
  const slug = context?.slug;
  const screenType = context?.screenType;
  const stepIndex = context?.stepIndex;
  const buildVersion = context?.buildVersion;

  useEffect(() => {
    // Страница ещё не знает, что показывает (идёт загрузка) — замерять нечего.
    if (!projectId || !slug || !screenType || stepIndex === undefined) return;
    let stop: (() => void) | null = null;
    let cancelled = false;
    void import('@/public/vitals')
      .then(({ initPublicVitals }) => {
        // Шаг успели сменить, пока грузился модуль — не заводим вовсе.
        if (cancelled) return;
        stop = initPublicVitals({
          projectId,
          slug,
          screenType,
          stepIndex,
          ...(buildVersion ? { buildVersion } : {}),
        });
      })
      .catch(() => {
        /* замер не загрузился — показу это ничего не меняет */
      });
    return () => {
      cancelled = true;
      stop?.();
    };
  }, [projectId, slug, screenType, stepIndex, buildVersion]);
}
